<template>
    <template v-for="catalog in this.listCatalogs" :key="catalog.ICatalogo">
        <CatalogCart 
            v-if="catalog.IdCatalogo in this.listaCataloghiArticoli" 
            :catalog="catalog" 
            :listaArticoli="this.listaCataloghiArticoli[catalog.IdCatalogo]"
            @UpdateCart ="this.resetCataloghiArticoli"
        />
    </template>
</template>

<script>
import CatalogCart from "@/components/CatalogCart.vue";

export default {
    name: "CatalogCartContainer",
    components: {
        CatalogCart
    },
    data(){
        return {
            listCatalogs: [],
            listaCataloghiArticoli: []
        }
    },
    props: {
        catalogs: Array
    },
    watch:{
        catalogs: function(newValue){
            this.listCatalogs = newValue
        }
    },
    methods: {
        setListaCatalghiArticoli: function(){
            if(this.$store.getters.getCarrello){
                let righeCarrelloAll = this.$store.getters.getCarrello.Righe;
                if(righeCarrelloAll != null && righeCarrelloAll.length > 0){
                    let righeCarrello = JSON.parse(JSON.stringify(righeCarrelloAll.filter(x => x.IsBackorder == 0)));
                    if(righeCarrello){
                        righeCarrello.forEach(articolo => {
                            if(!(articolo.Catalogo in this.listaCataloghiArticoli)){
                                this.listaCataloghiArticoli[articolo.Catalogo] = [];
                            }
                            this.listaCataloghiArticoli[articolo.Catalogo].push(articolo);
                        });
                    }
                }
            }
        },
        resetCataloghiArticoli: function(){
            this.listaCataloghiArticoli = [];
            this.setListaCatalghiArticoli();
            this.$emit("UpdateTotalCart");
        }
    },
    mounted: function(){
        if(this.listCatalogs.length == 0){
            this.listCatalogs = this.$store.getters.getCatalogs;
        }
        this.setListaCatalghiArticoli();
    }
}
</script>